import { render, staticRenderFns } from "./CampusEdit.vue?vue&type=template&id=bd1d1a7c&scoped=true&"
import script from "./CampusEdit.vue?vue&type=script&lang=js&"
export * from "./CampusEdit.vue?vue&type=script&lang=js&"
import style0 from "./CampusEdit.vue?vue&type=style&index=0&id=bd1d1a7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1d1a7c",
  null
  
)

export default component.exports